<template>
	<div class="dropdown inline-block relative w-full">
		<slot>
			<app-button
				:class="[`btn ${colorOfButton(status)} transparent w-full`, { small: size === 'small' }]"
				:icon="icon"
				:loading="loading"
				@click.stop=""
			>
				{{ label }}
			</app-button>
		</slot>
		<ul :class="`dropdown-menu absolute hidden text-gray-700 p-1 w-full ${position}-0`">
			<li v-for="(item, i) in items" :key="i">
				<a
					:class="[
						'bg-white hover:text-white py-2 px-4 block whitespace-no-wrap',
						status ? colorOfStatus(item.value) : colorOfStatus(status),
					]"
					@click="$emit('click', item)"
				>
					{{ item[labelProp] }}
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'AppDropdownButton',
		emits: ['click'],
		props: {
			status: {
				type: Number,
			},
			size: {
				type: String,
				default: 'normal',
			},
			icon: {
				type: String,
				default: 'sort-down',
			},
			label: {
				type: String,
				default: 'Options',
			},
			items: {
				type: Array,
				required: true,
			},
			labelProp: {
				type: String,
				default: 'label',
			},
			position: {
				type: String,
				default: 'left',
			},
			loading: {
				type: Boolean,
				default: false,
			},
		},
		methods: {
			colorOfStatus(value) {
				switch (Number(value)) {
					case 1:
						return 'hover:bg-warning';
					case 2:
						return 'hover:bg-success';
					case 3:
						return 'hover:bg-primary';
					default:
						return 'hover:bg-info';
				}
			},
			colorOfButton(value) {
				switch (Number(value)) {
					case 1:
						return 'btn-warning';
					case 2:
						return 'btn-success';
					case 3:
						return 'btn-primary';
					default:
						return 'btn-info';
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.dropdown:hover .dropdown-menu {
		@apply block bg-white z-10 cursor-pointer border-default w-32;
	}
</style>
